<div class="table-responsive-wrapper">
<div class="table-scroll-inner">
<table
  mat-table
  class="full-width-table"
  matSort
  aria-label="Orders Table"
  multiTemplateDataRows
  [dataSource]="dataSource"
>
  <!-- Select Column (checkbox + alarm indicator) -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef class="cabecera-tabla col-select" [style.width]="columnWidths['select']">
      <input
        type="checkbox"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
        (change)="$event ? masterToggle() : null"
        aria-label="Seleccionar todos"
      />
    </th>
    <td mat-cell *matCellDef="let row" class="col-select-cell">
      <div class="select-cell-inner">
        <input
          type="checkbox"
          [checked]="selection.isSelected(row)"
          (click)="$event.stopPropagation()"
          (change)="toggleRowSelection(row)"
          aria-label="Seleccionar fila"
        />
        <i
          *ngIf="row.require_action_note"
          class="icon-alarm-ringing text-warning ring-indicator"
          aria-hidden="true"
        ></i>
      </div>
    </td>
  </ng-container>

  <!-- Ring Column (notification icon) -->
  <ng-container matColumnDef="ring">
    <th mat-header-cell *matHeaderCellDef class="cabecera-tabla" [style.width]="columnWidths['ring']"></th>
    <td mat-cell *matCellDef="let row">
      <i
        *ngIf="row.require_action_note"
        class="icon-pencil text-success icon-alarm-ringing"
      ></i>
    </td>
  </ng-container>

  <!-- Info Column (unified: reference + agent + counterpart + vendor) -->
  <ng-container matColumnDef="info">
    <th mat-header-cell *matHeaderCellDef class="cabecera-tabla col-info" [style.width]="columnWidths['info']">
      {{ "inputs.reference" | translate }}
    </th>
    <td mat-cell *matCellDef="let row" class="col-info-cell">
      <div class="info-cell">

        <!-- BROKER account view -->
        <ng-container *ngIf="accountType === 'broker'">
          <div class="info-ref">{{ row?.broker_reference }}</div>
          <div class="info-tags" *ngIf="row.tags?.length">
            <span
              *ngFor="let tag of row.tags"
              class="badge tag-item tag-badge-spacing"
              [ngStyle]="{ 'background-color': tag.hex || tag.tag_hex, color: 'white' }"
            >{{ tag.name || tag.tag_name }}</span>
          </div>
          <!-- Collapsed only: counterpart names -->
          <ng-container *ngIf="expandedRow?.reference !== row.reference">
            <div class="info-secondary" *ngIf="row?.supplier?.name"><i class="icon-briefcase"></i>{{ row.supplier.name }}</div>
            <div class="info-secondary" *ngIf="row?.vendor?.name"><i class="icon-briefcase"></i>{{ row.vendor.name }}</div>
          </ng-container>
          <!-- Expanded: own agent + counterpart sections -->
          <ng-container *ngIf="expandedRow?.reference === row.reference">
            <div class="info-secondary" *ngIf="row?.broker_agent?.name"><i class="icon-user"></i>{{ row.broker_agent.name }} {{ row.broker_agent.lastname }}</div>
            <div class="info-secondary" *ngIf="row?.broker_sales_agent?.name"><i class="icon-briefcase"></i>{{ row.broker_sales_agent.fullname }}</div>
            <div class="info-section" *ngIf="row?.supplier?.name">
              <div class="info-label">{{ "inputs.supplier" | translate }}</div>
              <div class="info-name">{{ row.supplier.name }}</div>
              <div class="info-secondary" *ngIf="row?.supplier_reference"><i class="icon-barcode"></i>{{ row.supplier_reference }}</div>
              <div class="info-secondary" *ngIf="row?.supplier_agent?.name"><i class="icon-user"></i>{{ row.supplier_agent.name }} {{ row.supplier_agent.lastname }}</div>
            </div>
            <div class="info-section" *ngIf="row?.vendor?.name">
              <div class="info-label">{{ "inputs.vendor" | translate }}</div>
              <div class="info-name">{{ row.vendor.name }}</div>
              <div class="info-secondary" *ngIf="row?.vendor_reference"><i class="icon-barcode"></i>{{ row.vendor_reference }}</div>
            </div>
          </ng-container>
        </ng-container>

        <!-- SUPPLIER account view -->
        <ng-container *ngIf="accountType === 'supplier'">
          <div class="info-ref">{{ row?.supplier_reference }}</div>
          <div class="info-tags" *ngIf="row.tags?.length">
            <span
              *ngFor="let tag of row.tags"
              class="badge tag-item tag-badge-spacing"
              [ngStyle]="{ 'background-color': tag.hex || tag.tag_hex, color: 'white' }"
            >{{ tag.name || tag.tag_name }}</span>
          </div>
          <!-- Collapsed only: counterpart names -->
          <ng-container *ngIf="expandedRow?.reference !== row.reference">
            <div class="info-secondary" *ngIf="row?.broker?.name"><i class="icon-briefcase"></i>{{ row.broker.name }}</div>
            <div class="info-secondary" *ngIf="row?.vendor?.name"><i class="icon-briefcase"></i>{{ row.vendor.name }}</div>
          </ng-container>
          <!-- Expanded: own agent + counterpart sections -->
          <ng-container *ngIf="expandedRow?.reference === row.reference">
            <div class="info-secondary" *ngIf="row?.supplier_agent?.name"><i class="icon-user"></i>{{ row.supplier_agent.name }} {{ row.supplier_agent.lastname }}</div>
            <div class="info-section" *ngIf="row?.broker?.name">
              <div class="info-label">{{ "inputs.broker" | translate }}</div>
              <div class="info-name">{{ row.broker.name }}</div>
              <div class="info-secondary" *ngIf="row?.broker_reference"><i class="icon-barcode"></i>{{ row.broker_reference }}</div>
              <div class="info-secondary" *ngIf="row?.broker_agent?.name"><i class="icon-user"></i>{{ row.broker_agent.name }} {{ row.broker_agent.lastname }}</div>
              <div class="info-secondary" *ngIf="row?.broker_sales_agent?.name"><i class="icon-briefcase"></i>{{ row.broker_sales_agent.fullname }}</div>
            </div>
            <div class="info-section" *ngIf="row?.vendor?.name">
              <div class="info-label">{{ "inputs.vendor" | translate }}</div>
              <div class="info-name">{{ row.vendor.name }}</div>
              <div class="info-secondary" *ngIf="row?.vendor_reference"><i class="icon-barcode"></i>{{ row.vendor_reference }}</div>
            </div>
          </ng-container>
        </ng-container>

        <!-- OTHER account types (logistics, telemarketing, workshop) -->
        <ng-container *ngIf="accountType !== 'broker' && accountType !== 'supplier'">
          <div class="info-ref">{{ row?.supplier_reference }}</div>
          <div class="info-tags" *ngIf="row.tags?.length">
            <span
              *ngFor="let tag of row.tags"
              class="badge tag-item tag-badge-spacing"
              [ngStyle]="{ 'background-color': tag.hex || tag.tag_hex, color: 'white' }"
            >{{ tag.name || tag.tag_name }}</span>
          </div>
          <!-- Collapsed only: counterpart names -->
          <ng-container *ngIf="expandedRow?.reference !== row.reference">
            <div class="info-secondary" *ngIf="row?.broker?.name"><i class="icon-briefcase"></i>{{ row.broker.name }}</div>
            <div class="info-secondary" *ngIf="row?.supplier?.name"><i class="icon-briefcase"></i>{{ row.supplier.name }}</div>
            <div class="info-secondary" *ngIf="row?.vendor?.name"><i class="icon-briefcase"></i>{{ row.vendor.name }}</div>
          </ng-container>
          <!-- Expanded: counterpart sections -->
          <ng-container *ngIf="expandedRow?.reference === row.reference">
            <div class="info-section" *ngIf="row?.broker?.name">
              <div class="info-label">{{ "inputs.broker" | translate }}</div>
              <div class="info-name">{{ row.broker.name }}</div>
              <div class="info-secondary" *ngIf="row?.broker_reference"><i class="icon-barcode"></i>{{ row.broker_reference }}</div>
              <div class="info-secondary" *ngIf="row?.broker_agent?.name"><i class="icon-user"></i>{{ row.broker_agent.name }} {{ row.broker_agent.lastname }}</div>
              <div class="info-secondary" *ngIf="row?.broker_sales_agent?.name"><i class="icon-briefcase"></i>{{ row.broker_sales_agent.fullname }}</div>
            </div>
            <div class="info-section" *ngIf="row?.supplier?.name">
              <div class="info-label">{{ "inputs.supplier" | translate }}</div>
              <div class="info-name">{{ row.supplier.name }}</div>
              <div class="info-secondary" *ngIf="row?.supplier_reference"><i class="icon-barcode"></i>{{ row.supplier_reference }}</div>
              <div class="info-secondary" *ngIf="row?.supplier_agent?.name"><i class="icon-user"></i>{{ row.supplier_agent.name }} {{ row.supplier_agent.lastname }}</div>
            </div>
            <div class="info-section" *ngIf="row?.vendor?.name">
              <div class="info-label">{{ "inputs.vendor" | translate }}</div>
              <div class="info-name">{{ row.vendor.name }}</div>
              <div class="info-secondary" *ngIf="row?.vendor_reference"><i class="icon-barcode"></i>{{ row.vendor_reference }}</div>
            </div>
          </ng-container>
        </ng-container>

      </div>
    </td>
  </ng-container>

  <!-- Broker Reference Column -->
  <ng-container matColumnDef="broker_reference">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['broker_reference']"
      (click)="onSortChange2('broker_reference')"
    >
      {{ accountType === 'broker' ? ("inputs.reference_short" | translate) : ("inputs.broker_reference" | translate) }}
      <i
        *ngIf="sortColumn == 'broker_reference'"
        [ngClass]="getDirection()"
      ></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <span>{{ row?.broker_reference }}</span>
        <span
          *ngFor="let tag of row.tags; let i = index"
          class="badge tag-item tag-badge-spacing"
          [ngStyle]="{ 'background-color': tag.hex || tag.tag_hex, color: 'white' }"
        >
          {{ tag.name || tag.tag_name }}
        </span>
      </div>
    </td>
  </ng-container>

  <!-- Supplier Reference Column -->
  <ng-container matColumnDef="supplier_reference">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['supplier_reference']"
      (click)="onSortChange2('supplier_reference')"
    >
      {{ accountType === 'supplier' ? ("inputs.reference_short" | translate) : ("inputs.supplier_reference" | translate) }}
      <i
        *ngIf="sortColumn == 'supplier_reference'"
        [ngClass]="getDirection()"
      ></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <span>{{ row?.supplier_reference }}</span>
        <span
          *ngFor="let tag of row.tags; let i = index"
          class="badge tag-item tag-badge-spacing"
          [ngStyle]="{ 'background-color': tag.hex || tag.tag_hex, color: 'white' }"
        >
          {{ tag.name || tag.tag_name }}
        </span>
      </div>
    </td>
  </ng-container>

  <!-- Broker Agent Column -->
  <ng-container matColumnDef="broker_agent">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['broker_agent']"
      (click)="onSortChange2('broker_agent')"
    >
      {{ accountType === 'broker' ? ("inputs.agent_short" | translate) : ("inputs.broker_agent" | translate) }}
      <i
        *ngIf="sortColumn == 'broker_agent'"
        [ngClass]="getDirection()"
      ></i>
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row?.broker_agent?.name + " " + row?.broker_agent?.lastname }}
    </td>
  </ng-container>

  <!-- Broker Sales Agent Column -->
  <ng-container matColumnDef="broker_sales_agent">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['broker_sales_agent']"
    >
      {{ "inputs.broker_sales_agent" | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row?.broker_sales_agent?.fullname }}
    </td>
  </ng-container>

  <!-- Supplier Agent Column -->
  <ng-container matColumnDef="supplier_agent">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['supplier_agent']"
      (click)="onSortChange2('supplier_agent')"
    >
      {{ accountType === 'supplier' ? ("inputs.agent_short" | translate) : ("inputs.supplier_agent" | translate) }}
      <i
        *ngIf="sortColumn == 'supplier_agent'"
        [ngClass]="getDirection()"
      ></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <span *ngIf="row?.supplier_agent?.name">
        {{
          row?.supplier_agent?.name + " " + row?.supplier_agent?.lastname
        }}</span
      >
    </td>
  </ng-container>

  <!-- Broker Column -->
  <ng-container matColumnDef="broker">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['broker']"
      (click)="onSortChange2('broker')"
    >
      {{ "inputs.broker" | translate }}
      <i *ngIf="sortColumn == 'broker'" [ngClass]="getDirection()"></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <span *ngIf="row?.broker?.name"> {{ row?.broker?.name }}</span>
        <span *ngIf="row?.broker_reference" class="secondary-text">
          <i class="icon-barcode"></i> {{ row?.broker_reference }}</span
        >
        <div
          class="d-flex flex-column"
          *ngIf="
            expandedRow ? expandedRow.reference == row.reference : false
          "
        >
          <span *ngIf="row?.broker_agent?.name" class="secondary-text">
            <i class="icon-user"></i> {{ row?.broker_agent?.name }}
            {{ row?.broker_agent?.lastname }}</span
          >
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Supplier Column -->
  <ng-container matColumnDef="supplier">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['supplier']"
      (click)="onSortChange2('supplier')"
    >
      {{ "inputs.supplier" | translate }}
      <i *ngIf="sortColumn == 'supplier'" [ngClass]="getDirection()"></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <span *ngIf="row?.supplier?.name">
          {{ row?.supplier?.name }}</span
        >
        <span *ngIf="row?.supplier_reference" class="secondary-text">
          <i class="icon-barcode"></i> {{ row?.supplier_reference }}</span
        >
        <div
          class="d-flex flex-column"
          *ngIf="
            expandedRow ? expandedRow.reference == row.reference : false
          "
        >
          <span *ngIf="row?.supplier_agent?.name" class="secondary-text">
            <i class="icon-user"></i> {{ row?.supplier_agent?.name }}
            {{ row?.supplier_agent?.lastname }}</span
          >
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Vendor Column -->
  <ng-container matColumnDef="vendor">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['vendor']"
      (click)="onSortChange2('vendor')"
    >
      {{ "inputs.vendor" | translate }}
      <i *ngIf="sortColumn == 'vendor'" [ngClass]="getDirection()"></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <span *ngIf="row?.vendor?.name"> {{ row?.vendor?.name }}</span>
        <span *ngIf="row?.vendor_reference" class="secondary-text">
          <i class="icon-barcode"></i> {{ row?.vendor_reference }}</span
        >
        <div
          class="d-flex flex-column"
          *ngIf="
            expandedRow ? expandedRow.reference == row.reference : false
          "
        >
          <span *ngIf="row?.broker_agent?.agent" class="secondary-text">
            <i class="icon-user"></i> {{ row?.broker_agent?.name }}</span
          >
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Client Column -->
  <ng-container matColumnDef="client">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['client']"
      (click)="onSortChange2('client')"
    >
      {{ "inputs.client" | translate }}
      <i *ngIf="sortColumn == 'client'" [ngClass]="getDirection()"></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <span *ngIf="row?.client?.name"
          [class.text-truncate-cell]="expandedRow?.reference !== row.reference">
          {{ row?.client?.name }}
          {{ row?.client?.lastname ? row?.client?.lastname : "" }}</span
        >

        <div
          class="d-flex flex-column"
          *ngIf="
            expandedRow ? expandedRow.reference == row.reference : false
          "
        >
          <span *ngIf="row?.client?.phone" class="secondary-text">
            {{ row?.client?.tax_id }}</span
          >

          <span *ngIf="row?.guarantee?.name">
            {{ "inputs.guarantee" | translate }} :
            {{ row?.guarantee?.name }}
            {{
              row?.guarantee?.lastname ? row?.guarantee?.lastname : ""
            }}</span
          >

          <span *ngIf="row?.guarantee?.phone" class="secondary-text">
            {{ row?.guarantee?.tax_id }}</span
          >
        </div>

        <span
          *ngIf="row?.client?.name"
          class="badge tag-item tag-badge-spacing"
          [ngClass]="row.client?.type | badgeClient"
          >{{ "inputs." + row.client?.type | translate }}</span
        >

        <span
          *ngIf="
            row?.delivery_contact &&
            row?.delivery_contact !=
              row?.client?.name + ' ' + row?.client?.lastname
          "
          class="secondary-text"
        >
          <i class="icon-hand-waving"></i>
          {{ row?.delivery_contact }}</span
        >
      </div>
    </td>
  </ng-container>

  <!-- Vehicle Column -->
  <ng-container matColumnDef="vehicle">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['vehicle']"
      (click)="onSortChange2('vehicle')"
    >
      {{ "inputs.vehicle" | translate }}
      <i *ngIf="sortColumn == 'vehicle'" [ngClass]="getDirection()"></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <span
          *ngIf="row?.campaign_name"
          class="badge tag-item tag-badge-spacing"
          [ngClass]="'campaign' | badgeClient"
          [class.text-truncate-cell]="expandedRow?.reference !== row.reference"
          ><i class="icon-bullhorn text-sm"></i>
          {{ row?.campaign_name }}</span
        >
        <span *ngIf="row?.vehicle"
          [class.text-truncate-cell]="expandedRow?.reference !== row.reference">
          {{ row?.vehicle_units ? row.vehicle_units : 1 }}x
          {{ row?.vehicle_brand }} {{ row?.vehicle_model }}
        </span>
        <span *ngIf="row?.vehicle"
          [class.text-truncate-cell]="expandedRow?.reference !== row.reference"
          >{{ row?.vehicle }} ({{ row?.vehicle_model_year }})</span
        >
        <div class="badges-stacked" *ngIf="row?.type || row?.vehicle_status">
          <span
            *ngIf="row?.type"
            class="badge tag-item tag-badge-spacing"
            [ngClass]="row.type | badgeVehicle"
            >{{
              "badge-status_select-stage." + row?.type | translate
            }}</span
          >
          <span
            *ngIf="row?.vehicle_status"
            class="badge tag-item tag-badge-spacing"
            [ngClass]="row.vehicle_status | badgeVehicle"
            >{{
              "badge-status_select-stage." + row?.vehicle_status | translate
            }}</span
          >
        </div>

        <div
          class="d-flex flex-column"
          *ngIf="
            expandedRow ? expandedRow.reference == row.reference : false
          "
        >
          <span *ngIf="row?.colour" class="secondary-text">
            <i class="icon-brush2"></i> {{ row?.colour }}</span
          >
          <span class="area-table"></span>
          <span *ngIf="row?.vin" class="secondary-text">
            {{ row?.vin }}</span
          >
          <span *ngIf="row?.duration" class="secondary-text">
            {{ row?.duration }}
            {{ "tables.months" | translate }}</span
          >
          <span *ngIf="row?.total_kms" class="secondary-text">
            {{ row?.total_kms }} kms</span
          >
          <span *ngIf="row?.license_plate" class="secondary-text">
            {{ row?.license_plate }}</span
          >
          <span *ngIf="row?.monthly_fee_total" class="secondary-text">
            <i class="icon-coin-euro"> </i>
            {{ row?.monthly_fee_total }} Є/{{
              "tables.month" | translate
            }}</span
          >
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Documents Column -->
  <ng-container matColumnDef="documents">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['documents']"
      (click)="onSortChange2('documents')"
    >
      {{ "inputs.documents" | translate }}
      <i *ngIf="sortColumn == 'documents'" [ngClass]="getDirection()"></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <div *ngFor="let doc of row?.order_documents">
          <ng-container *ngIf="doc.type === 'vendor_order'">
            <div
              class="d-flex align-items-center type"
              (click)="handleClickDocument(doc.file, $event)"
            >
              <i class="icon-download2"></i>
              <div
                class="type"
                [ngStyle]="{ 'background-color': pickAColor(doc.type) }"
              >
                {{
                  "select.document_type." + doc.type + "_short"
                    | translate
                }}
              </div>
              <div
                class="type"
                *ngIf="doc.visibility == 'private'"
                [ngStyle]="{ 'background-color': pickAColor('private') }"
              >
                <i class="icon-lock"></i>
              </div>
            </div>
            <span class="secondary-text"
              >({{ doc.created_at | date: "dd/MM/yyyy HH:mm" }})</span
            >
          </ng-container>
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Telemarketing Column -->
  <ng-container matColumnDef="telemarketing">
    <th mat-header-cell *matHeaderCellDef class="cabecera-tabla" [style.width]="columnWidths['telemarketing']">
      {{ "inputs.telemarketing" | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="column-list">
        <div
          *ngIf="row.telemarketing_status_name"
          class="telemarketing-info"
        >
          <span>
            {{ row.telemarketing_status_name }}
          </span>
          <br />
          <span
            *ngIf="row?.telemarketing_action_date"
            class="secondary-text"
          >
            <i class="icon-clock"></i>
            {{ row.telemarketing_action_date | date: "dd/MM/yyyy HH:mm" }}
          </span>
        </div>
        <span
          *ngIf="row.telemarketing_action_status_name"
          class="badge tag-item tag-badge-spacing"
          [ngClass]="row.telemarketing_action_status_name | badgeDelivery"
        >
          {{ row?.telemarketing_action_status_name | translate }}
        </span>
      </div>
    </td>
  </ng-container>

  <!-- Vehicle Manufacturing Date Column -->
  <ng-container matColumnDef="vehicle_manufacturing_date">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['vehicle_manufacturing_date']"
      (click)="onSortChange2('vehicle_manufacturing_date')"
    >
      {{ "inputs.vehicle_manufacturing_date" | translate }}
      <i
        *ngIf="sortColumn == 'vehicle_manufacturing_date'"
        [ngClass]="getDirection()"
      ></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="d-flex flex-column">
        <div class="column-list">
          <span *ngIf="row?.vehicle_manufacturing_date">
            {{ row?.vehicle_manufacturing_date | formatDateTimePipe }}
          </span>
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Delivery Expected Date Column -->
  <ng-container matColumnDef="delivery_expected_date">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla"
      [style.width]="columnWidths['delivery_expected_date']"
      (click)="onSortChange2('delivery_expected_date')"
    >
      {{ "inputs.delivery_expected_date" | translate }}
      <i
        *ngIf="sortColumn == 'delivery_expected_date'"
        [ngClass]="getDirection()"
      ></i>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="d-flex flex-column">
        <div class="column-list">
          <span *ngIf="row?.delivery_expected_date">
            {{ row?.delivery_expected_date | formatDateTimePipe }}
          </span>
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Updated At Column -->
  <ng-container matColumnDef="updated_at">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla col-date"
      [style.width]="columnWidths['updated_at']"
      (click)="onSortChange2('updated_at')"
    >
      {{ "inputs.updated_at" | translate }}
      <i
        *ngIf="sortColumn == 'updated_at'"
        [ngClass]="getDirection()"
      ></i>
    </th>
    <td mat-cell *matCellDef="let row" class="col-date-cell">
      <div
        class="d-flex flex-column"
        *ngIf="
          expandedRow ? expandedRow.reference == row.reference : false;
          else notExpanded
        "
      >
        <div class="date-block">
          <span *ngIf="row?.updated_at" class="date-value">
            {{ row?.updated_at | formatDateTimePipe }}
          </span>
          <span *ngIf="row?.updated_at" class="date-user">
            <i class="icon-user"></i>
            {{ row?.updated_by }}
          </span>
        </div>
      </div>
      <ng-template #notExpanded>
        <div class="date-block">
          <span *ngIf="row?.updated_at" class="date-value">
            {{ row?.updated_at | date: "dd/MM/yyyy" }}
          </span>
          <span *ngIf="row?.updated_at" class="date-user">
            <i class="icon-user"></i>
            {{ row?.updated_by }}
          </span>
        </div>
      </ng-template>
    </td>
  </ng-container>

  <!-- Stage Updated At Column -->
  <ng-container matColumnDef="stage_updated_at">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla col-date"
      [style.width]="columnWidths['stage_updated_at']"
      (click)="onSortChange2('stage_updated_at')"
    >
      {{ "inputs.stage_updated_at" | translate }}
      <i
        *ngIf="sortColumn == 'stage_updated_at'"
        [ngClass]="getDirection()"
      ></i>
    </th>
    <td mat-cell *matCellDef="let row" class="col-date-cell">
      <div
        class="d-flex flex-column"
        *ngIf="
          expandedRow ? expandedRow.reference == row.reference : false;
          else notExpanded1
        "
      >
        <div class="date-block">
          <span *ngIf="row?.stage_updated_at" class="date-value">
            {{ row?.stage_updated_at | formatDateTimePipe }}</span
          >
          <span *ngIf="row?.stage_updated_by" class="date-user">
            <i class="icon-user"></i> {{ row?.stage_updated_by }}</span
          >
        </div>
      </div>
      <ng-template #notExpanded1>
        <div class="date-block">
          <span *ngIf="row?.stage_updated_at" class="date-value">
            {{ row?.stage_updated_at | date: "dd/MM/yyyy" }}</span
          >
          <span *ngIf="row?.stage_updated_by" class="date-user">
            <i class="icon-user"></i> {{ row?.stage_updated_by }}</span
          >
        </div>
      </ng-template>
    </td>
  </ng-container>

  <!-- Stage Column -->
  <ng-container matColumnDef="stage">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="cabecera-tabla col-stage"
      [style.width]="columnWidths['stage']"
      (click)="onSortChange2('stage')"
    >
      {{ "inputs.stage" | translate }}
      <i *ngIf="sortColumn == 'stage'" [ngClass]="getDirection()"></i>
    </th>
    <td mat-cell *matCellDef="let row" class="col-stage-cell">
      <div class="column-list">
        <span
          class="badge tag-item tag-badge-spacing"
          [ngClass]="row.stage | badgeColor:row.require_action:row.priority"
          >{{
            "badge-status_select-stage." + row?.stage | translate
          }}</span
        >
        <span
          *ngIf="row.delivery_status && typeOrders?.startsWith('after-sales')"
          class="badge tag-item tag-badge-spacing"
          [ngClass]="row.delivery_status | badgeDelivery"
        >
          {{
            "badge-status_select-stage." + row?.delivery_status
              | translate
          }}
        </span>
        <span *ngIf="row?.old_stage" class="secondary-text">
          <i *ngIf="typeOrders == 'frozen'" class="icon-snow2"></i>
          <i
            *ngIf="typeOrders == 'cancelled'"
            class="icon-cross-circle"
          ></i>
          <i class="icon-undo" title="Etapa anterior"></i>
          {{
            "badge-status_select-stage." + row?.old_stage | translate
          }}</span
        >
      </div>
    </td>
  </ng-container>

  <!-- Actions Column (pencil + trash) -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef class="cabecera-tabla col-actions" [style.width]="columnWidths['actions']"></th>
    <td mat-cell *matCellDef="let row">
      <i
        class="icon-pencil text-success icon-actions"
        (click)="getOrder(row.reference, $event)"
        [matTooltip]="'tooltip.editorder' | translate"
        aria-hidden="true"
      ></i>
      <i
        *ngIf="userRole === 'Sales'"
        class="icon-register text-primary icon-actions"
        (click)="openNotesClick.emit(row.reference); $event.stopPropagation()"
        [matTooltip]="'tooltip.opennotes' | translate"
        aria-hidden="true"
      ></i>
      <i
        *ngIf="row.stage == 'draft' || row.stage == 'sql'"
        class="icon-trash text-danger icon-actions"
        (click)="deleteOrder(row.reference, $event)"
        [matTooltip]="'tooltip.deleteorder' | translate"
        aria-hidden="true"
      ></i>
    </td>
  </ng-container>

  <!-- Header Row -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

  <!-- Data Row -->
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    (click)="onRowClickHandler(row)"
    [ngClass]="{
      'tr-selected': expandedRow?.reference === row.reference
    }"
  ></tr>

  <!-- No Data Row -->
  <tr class="mat-mdc-row" *matNoDataRow>
    <td class="mat-mdc-cell no-data-cell" [attr.colspan]="displayedColumns.length">
      <div class="no-data-row">
        <i class="icon-info"></i>
        {{ 'tables.no_results' | translate }} (0)
      </div>
    </td>
  </tr>
</table>
</div>
</div>

<!-- ============================================
     CARDS MOBILE — Visible solo < 768px
     ============================================ -->
<div class="cards-mobile-wrapper">

  <!-- Loading state -->
  <div *ngIf="loading" class="cards-loading">
    <div class="spinner"></div>
  </div>

  <!-- Estado vacio -->
  <div *ngIf="!loading && orders.length === 0" class="cards-empty">
    {{ 'tables.no_results' | translate }}
  </div>

  <!-- Cards -->
  <div
    *ngFor="let row of orders"
    class="order-card"
    [class.require-action]="$any(row).require_action_note"
    (click)="onRowClickHandler(row)"
  >
    <!-- Header: checkbox + referencia + stage badge -->
    <div class="card-header">
      <input
        type="checkbox"
        [checked]="selection.isSelected(row)"
        (click)="$event.stopPropagation()"
        (change)="toggleRowSelection(row)"
        aria-label="Seleccionar orden"
      />
      <div class="card-header-content">
        <div class="card-header-top">
          <span class="card-ref">
            {{ accountType === 'supplier' ? $any(row)?.supplier_reference : row?.broker_reference }}
          </span>
          <span class="card-stage">
            <span
              class="badge tag-item tag-badge-spacing"
              [ngClass]="row.stage | badgeColor:$any(row).require_action:$any(row).priority"
            >{{ 'badge-status_select-stage.' + row?.stage | translate }}</span>
          </span>
        </div>

        <!-- Tags (max 3) -->
        <div class="card-tags" *ngIf="$any(row).tags?.length">
          <span
            *ngFor="let tag of $any(row).tags | slice:0:3"
            class="badge tag-item tag-badge-spacing"
            [ngStyle]="{ 'background-color': $any(tag).hex || $any(tag).tag_hex, color: 'white' }"
          >{{ $any(tag).name || $any(tag).tag_name }}</span>
        </div>
      </div>
    </div>

    <!-- Body: cliente, vehiculo, fecha -->
    <div class="card-body-content">
      <!-- Cliente -->
      <span *ngIf="row?.client?.name">
        <i class="icon-user"></i>
        {{ row.client.name }} {{ row.client.lastname || '' }}
        <span
          *ngIf="$any(row)?.client?.type"
          class="badge tag-item tag-badge-spacing card-client-type"
          [ngClass]="$any(row).client.type | badgeClient"
        >{{ 'inputs.' + $any(row).client.type | translate }}</span>
      </span>

      <!-- Vehiculo -->
      <span *ngIf="row?.vehicle">
        <i class="icon-car"></i>
        <span *ngIf="$any(row)?.vehicle_units">{{ $any(row).vehicle_units }}x </span>
        {{ $any(row).vehicle_brand }} {{ $any(row).vehicle_model }}
        <span *ngIf="$any(row)?.vehicle_model_year">({{ $any(row).vehicle_model_year }})</span>
        <span *ngIf="$any(row)?.type" class="badge tag-item tag-badge-spacing"
          [ngClass]="$any(row).type | badgeVehicle">{{
            "badge-status_select-stage." + $any(row)?.type | translate
          }}</span>
        <span *ngIf="$any(row)?.vehicle_status" class="badge tag-item tag-badge-spacing"
          [ngClass]="$any(row).vehicle_status | badgeVehicle">{{
            "badge-status_select-stage." + $any(row)?.vehicle_status | translate
          }}</span>
      </span>

      <!-- Fecha actualizacion -->
      <span *ngIf="$any(row)?.updated_at">
        <i class="icon-clock"></i>
        {{ $any(row).updated_at | date:'dd/MM/yyyy' }}
        <span *ngIf="$any(row)?.updated_by" class="secondary-text">{{ $any(row).updated_by }}</span>
      </span>
    </div>

    <!-- Footer: delivery badge + acciones -->
    <div class="card-footer">
      <div class="card-delivery-badge">
        <span
          *ngIf="$any(row).delivery_status && typeOrders?.startsWith('after-sales')"
          class="badge tag-item tag-badge-spacing"
          [ngClass]="$any(row).delivery_status | badgeDelivery"
        >{{ 'badge-status_select-stage.' + $any(row)?.delivery_status | translate }}</span>
      </div>
      <div class="card-actions">
        <i
          *ngIf="row.stage === 'draft' || row.stage === 'sql'"
          class="icon-trash text-danger"
          (click)="deleteOrder(row.reference, $event)"
          aria-hidden="true"
        ></i>
        <i
          class="icon-pencil text-success"
          (click)="getOrder(row.reference, $event)"
          aria-hidden="true"
        ></i>
        <i
          *ngIf="userRole === 'Sales'"
          class="icon-register text-primary"
          (click)="openNotesClick.emit(row.reference); $event.stopPropagation()"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  </div>
</div>
